import React, { useEffect, useState, useRef } from 'react';

import ShowViewPhoto from '@/pages/components/dialog/viewPhoto';
import imgCorner from '@/assets/images/wish/corner.png';
import imgFlag from '@/assets/images/wish/flag.png';
// import Viewer from "react-viewer";
import imgBtnBack from '@/assets/images/btn/btnBack.png';

import {DEL_WISH} from '@/services/wish';
// import { useNavigate } from 'react-router-dom';

import styles from './index.less';

const Paper=(props)=>{
  const {wish,showBack=false,id} = props;
  const {content='愿望',name='姓名',school='学校',class:classname='班级',photo=''} = wish;
  // const navigate = useNavigate();
  const onViewPhoto=()=>{
    ShowViewPhoto({src:photo});
  }
  const onBack= async ()=>{
    const req= await DEL_WISH(id);
    if(req?.code==0){
      // navigate('/');
      location.replace('/#/');
    }

  }
  return (
    <section className={`${styles.wrap}`}>
      <section className={styles.position} >

        <section className={styles.row1}>
          <img className={styles.flagStart} src={imgFlag} />
          <span className={styles.labelTitle}>TA的愿望是：</span>
        </section>
        <section className={styles.row2}>
          <span className={styles.labelWish}>{content}</span>
        </section>
        <section className={styles.row3}>
          <span className={styles.address}>{name} {school}-{classname}</span>
          <img className={styles.flagEnd} src={imgFlag} />
        </section>

        <section className={styles.photoWrap}>
          <section className={styles.photoView} onClick={onViewPhoto}>
            <img className={styles.photo} src={photo} />
          </section>
          <img className={styles.corner} src={imgCorner} />
        </section>
        {/* {
          showBack&&
          wish?.state!='Completed'
          &&
          <section className={styles.backWrap}>
            <img src={imgBtnBack} className={styles.btnBack} onClick={onBack} />
          </section>
        } */}
      </section>
    </section>
  )
}

export default Paper;